import { CHAT_NOTIFICATION_TYPE } from '../../../constants/notifications/constants';

const getAllNotifications = state => structuredClone(state.notifications);

const getNotificationsForElement = state => elementId => structuredClone(state.notifications.chats[elementId]);

const getUnreadMessagesNotificationsForElement = state => elementId => {
  const unreadMessagesOnly = notification => notification.type === CHAT_NOTIFICATION_TYPE.message.unread;
  return (state.notifications.chats[elementId] || []).filter(unreadMessagesOnly);
};

const getNumberOfNotificationsForInteraction = (state, getters, rootState, rootGetters) => interactionId => {
  const elementIds = rootGetters['ELEMENTS/getElementIdsByInteractionId'](interactionId);
  return elementIds
    .map(id => getters.getUnreadMessagesNotificationsForElement(id).length)
    .reduce((accum, currentValue) => accum + currentValue, 0);
};

const getTotalChatInteractionsWithNotifications = (state, getters, rootState, rootGetters) => {
  const activeInteractions = rootGetters['INTERACTIONS/getActiveInteractions'];
  return activeInteractions.filter(
    interaction => interaction.isChat && !!getters.getNumberOfNotificationsForInteraction(interaction.interactionId)
  ).length;
};

const getTotalSmsInteractionsWithNotifications = (state, getters, rootState, rootGetters) => {
  const activeInteractions = rootGetters['INTERACTIONS/getActiveInteractions'];
  return activeInteractions.filter(
    interaction => interaction.isSms && !!getters.getNumberOfNotificationsForInteraction(interaction.interactionId)
  ).length;
};

const getTotalInteractionsWithNotifications = (state, getters) => {
  return getters.getTotalChatInteractionsWithNotifications;
};

const getCallbacks = state => {
  if (state.notifications.callbacks) {
    return structuredClone(state.notifications.callbacks);
  } else {
    return [];
  }
};

const getSystemNotifications = state => {
  if (state.notifications.system && state.notifications.system.messages) {
    return structuredClone(state.notifications.system.messages);
  } else {
    return [];
  }
};

const getUnreadSystemNotifications = state => {
  return state.notifications.system.unread;
};

export default {
  getAllNotifications,
  getNotificationsForElement,
  getUnreadMessagesNotificationsForElement,
  getNumberOfNotificationsForInteraction,
  getTotalChatInteractionsWithNotifications,
  getTotalInteractionsWithNotifications,
  getCallbacks,
  getSystemNotifications,
  getUnreadSystemNotifications,
  getTotalSmsInteractionsWithNotifications
};
